// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-help-index-wrapper-bdqvb{display:grid;grid-gap:48px}.pages-help-index-wrapper-bdqvb.pages-help-index-desktop-bpgom{grid-template-columns:repeat(4,1fr)}.pages-help-index-pageWrapper-ccfel{padding-bottom:48px}.pages-help-index-pageWrapper-ccfel.pages-help-index-mobile-bndkm{padding-top:48px}.pages-help-index-link-iadiv{color:#111;display:block;text-decoration:none}.pages-help-index-link-iadiv:hover{color:var(--color-primary-hover)}.pages-help-index-title-bxbns{font-size:20px;font-weight:700;text-align:center}.pages-help-index-image-bjbyv{border-radius:6px;height:auto!important;margin-bottom:12px;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-help-index-wrapper-bdqvb",
	"desktop": "pages-help-index-desktop-bpgom",
	"pageWrapper": "pages-help-index-pageWrapper-ccfel",
	"mobile": "pages-help-index-mobile-bndkm",
	"link": "pages-help-index-link-iadiv",
	"title": "pages-help-index-title-bxbns",
	"image": "pages-help-index-image-bjbyv"
};
module.exports = ___CSS_LOADER_EXPORT___;
